import { Organization } from "schemas/dashboard";

export const isDemoUser = (currentOrg?: Organization | null) => {
  if (!currentOrg?.id) {
    return false;
  }

  const demo_ids = process.env.REACT_APP_DEMO_USER_IDS?.split(",").map((v) =>
    Number(v),
  );

  return demo_ids?.includes(currentOrg.id);
};
